import React, { createContext, useContext, useState, useEffect } from "react"
import API from "../api/axios"

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user,      setUser]      = useState(null)
  const [admin,     setAdmin]     = useState(null)
  const [loading,   setLoading]   = useState(true)

  // Re-hydrate on refresh
  useEffect(() => {
    const token     = localStorage.getItem("ra_token")
    const tokenType = localStorage.getItem("ra_token_type") // "user" | "admin"
    if (!token) { setLoading(false); return }

    const verify = async () => {
      try {
        if (tokenType === "admin") {
          const { data } = await API.get("/auth/me")
          setAdmin(data.admin)
        } else {
          const { data } = await API.get("/users/me")
          setUser(data.user)
        }
      } catch {
        localStorage.removeItem("ra_token")
        localStorage.removeItem("ra_token_type")
      } finally {
        setLoading(false)
      }
    }
    verify()
  }, [])

  // ── User auth ──────────────────────────────────────────
  const userRegister = async (name, email, phone, password) => {
    const { data } = await API.post("/users/register", { name, email, phone, password })
    localStorage.setItem("ra_token", data.token)
    localStorage.setItem("ra_token_type", "user")
    setUser(data.user)
    return data
  }

  const userLogin = async (email, password) => {
    const { data } = await API.post("/users/login", { email, password })
    localStorage.setItem("ra_token", data.token)
    localStorage.setItem("ra_token_type", "user")
    setUser(data.user)
    return data
  }

  const userLogout = () => {
    localStorage.removeItem("ra_token")
    localStorage.removeItem("ra_token_type")
    setUser(null)
  }

  // ── Admin auth ─────────────────────────────────────────
  const adminLogin = async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password })
    localStorage.setItem("ra_token", data.token)
    localStorage.setItem("ra_token_type", "admin")
    setAdmin(data.admin)
    return data
  }

  const adminLogout = () => {
    localStorage.removeItem("ra_token")
    localStorage.removeItem("ra_token_type")
    setAdmin(null)
  }

  return (
    <AuthContext.Provider value={{
      user, admin, loading,
      userRegister, userLogin, userLogout,
      adminLogin, adminLogout,
      isUser: !!user,
      isAdmin: !!admin,
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider")
  return ctx
}
